export default "__VITE_ASSET__C4CRB$He__"